export const createAudioEl = (id: string): HTMLAudioElement => {
  const ex = document.getElementById(id) as HTMLAudioElement | null;
  if (ex) return ex;
  const el = document.createElement('audio');
  el.id = id;
  el.preload = 'auto';
  el.style.display = 'none';
  document.body.appendChild(el);
  return el;
};

export const removeAudioElById = (id: string) => {
  const el = document.getElementById(id) as HTMLAudioElement | null;
  if (!el) return;

  // prettier-ignore
  // eslint-disable-next-line no-empty
  try { el.pause() } catch {}
  el?.remove();
};

export const removeAudioEl = (el?: HTMLAudioElement | null) => {
  if (!el) return;
  // prettier-ignore
  // eslint-disable-next-line no-empty
  try { el.pause() } catch {}
  if (el.isConnected) el.remove();
};
